/* beautiful-react-hooks version: 0.31.1 */
import { useRef } from 'react';

var getInitial = function getInitial(module) {
  return {
    module: module,
    renders: 0,
    timestamp: null,
    sinceLast: null
  };
};

var useRenderInfo = function useRenderInfo() {
  var module = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Unknown component';
  var log = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var _useRef = useRef(getInitial(module)),
      info = _useRef.current;

  var now = +Date.now();
  info.renders += 1;
  info.sinceLast = info.timestamp ? (now - info.timestamp) / 1000 : '[now]';
  info.timestamp = now;

  if (log) {
    console.group("".concat(module, " info"));
    console.log("Render no: ".concat(info.renders).concat(info.renders > 1 ? ", ".concat(info.sinceLast, "s since last render") : ''));
    console.dir(info);
    console.groupEnd();
  }

  return info;
};

export default useRenderInfo;
